module.exports = __webpack_public_path__ + "static/media/RuGettingDirectionsDDO.459c7d84.pdf";